import React, {useEffect, useState} from 'react';
import AdminMenu from '../../components/Layout/AdminMenu';
import Layout from '../../components/Layout/Layout';
import toast from 'react-hot-toast';
import axios from 'axios';
import CategoryForm from '../../components/Form/CategoryForm';
import { Modal } from "antd";
import '../../styles/AdminStyles.css';

const CreateCategory = () => {
  const [categories,setCategories] = useState([]);
  const [name, setName] = useState("");
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const [updatedName, setUpdatedName] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("/api/v1/category/create-category", {
        name,
      });
      if (data?.success) {
        toast.success(`تم إنشاء ${name} بنجاح`);
        getAllCategory();
        setName("");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("حدث خطأ في إدخال البيانات");
    }
  };

  const getAllCategory= async() => {
    try {
      const {data} = await axios.get('/api/v1/category/get-category');
      if (data?.success) {
        setCategories(data?.category);
      }
    } catch (error) {
      console.log(error);
      toast.error('حدث خطأ في جلب الأقسام');
    }
  };

  useEffect(() => {
    getAllCategory();
  },[]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.put(
        `/api/v1/category/update-category/${selected._id}`,
        { name: updatedName }
      );
      if (data.success) {
        toast.success(`تم تحديث ${updatedName} بنجاح`);
        setSelected(null);
        setUpdatedName("");
        setVisible(false);
        getAllCategory();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("حدث خطأ ما");
    }
  };

  const handleDelete = async (pId) => {
    try {
      const { data } = await axios.delete(
        `/api/v1/category/delete-category/${pId}`
      );
      if (data.success) {
        toast.success(`تم حذف القسم بنجاح`);
        getAllCategory();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("حدث خطأ ما");
    }
  };

  return (
    <Layout title={'إدارة الأقسام - النخبة ستور'}>
      <div className='container-fluid admin-layout'>
        <div className='row'>
          <div className='col-md-3'>
            <AdminMenu/>
          </div>
          <div className='col-md-9'>
            <div className="admin-page-header">
              <h1>إدارة الأقسام</h1>
              <p>إنشاء وتعديل وحذف أقسام المتجر</p>
              <div className="admin-page-header-line"></div>
            </div>

            <div className="admin-form-card mb-4">
              <CategoryForm
                handleSubmit={handleSubmit}
                value={name}
                setValue={setName}
              />
            </div>

            <div className="admin-card">
              <div className="admin-table-wrapper">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>الاسم</th>
                      <th>الإجراءات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories?.map((c) => (
                      <tr key={c._id}>
                        <td style={{fontWeight: 600, color: 'var(--white)'}}>{c.name}</td>
                        <td>
                          <button className='btn btn-primary ms-2' onClick={() => {
                            setVisible(true);
                            setUpdatedName(c.name);
                            setSelected(c);
                          }}>تعديل</button>
                          <button className='btn btn-danger ms-2' onClick={() => {
                            handleDelete(c._id);
                          }}>حذف</button>
                        </td>
                      </tr>
                    ))}
                    {categories?.length === 0 && (
                      <tr>
                        <td colSpan="2" style={{textAlign: 'center', padding: '30px', color: 'var(--white-muted)'}}>
                          لا توجد أقسام بعد
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <Modal onCancel={() => setVisible(false)}
              footer={null}
              open={visible}>
              <CategoryForm
                value={updatedName}
                setValue={setUpdatedName}
                handleSubmit={handleUpdate}
              />
            </Modal>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CreateCategory;
